// extracted by mini-css-extract-plugin
export var box = "_3g-0";
export var check = "_3g-1";
export var checkboxButton = "_3g-6";
export var checkboxGroup = "_3g-5";
export var disabled = "_3g-7";
export var ghost = "_3g-9";
export var input = "_3g-2";
export var label = "_3g-4";
export var normal = "_3g-8";
export var uncheck = "_3g-3";